import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../utils/api';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError('');
    setMessage('');
    setLoading(true);

    try {
      const response = await forgotPassword({ email: email.trim() });

      if (response.status === false || response.success === false) {
        setError(response.message || 'Could not send reset link.');
        return;
      }

      setMessage(response.message || 'Password reset link sent.');
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || 'Could not send reset link.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-4 py-12">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl border border-gray-100 p-8">
        <h1 className="text-3xl font-playfair-display font-semibold text-primary mb-3">
          Forgot Password
        </h1>

        <p className="text-secondary mb-6">
          Enter your email and we’ll send you a reset link.
        </p>

        {error && <div className="mb-4 p-4 bg-red-50 text-red-700 rounded-xl">{error}</div>}
        {message && <div className="mb-4 p-4 bg-green-50 text-green-700 rounded-xl">{message}</div>}

        <form onSubmit={handleSubmit} className="space-y-5">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            className="w-full px-5 py-4 border border-gray-300 rounded-xl focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/30"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-primary text-cream py-4 rounded-full font-medium disabled:opacity-60"
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <p className="mt-6 text-center">
          <Link to="/login" className="text-primary font-medium">
            Back to Login
          </Link>
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;